class PenalidadesNotificacoesUrlBuilder {
	constructor(tipo) {
		this.PATH = tipo.path
	}

	getUrlBuscarNotificacoesPenalidade(idPenalidade) {
		return `api/${this.PATH}/penalidades/${idPenalidade}/infracoes`
	}

	getUrlInserirNotificacaoPenalidade() {
		return `api/${this.PATH}/penalidades/infracoes`
	}
}

export default PenalidadesNotificacoesUrlBuilder
